<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title> <b>PARENT/GUARDIAN INFORMATION (FOR GRADES P3-P5, K-12)
      </b>
	  <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_ParentGuardian_Overview'"></help-text-btn>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <form [formGroup]="frmParentGuardian">
    <!-- Current Parent/Guardian 1  Relationship  Phone 1-->
    <div class="row">
      <div class="col-4 inline">
        <mat-form-field class="w-100">
          <mat-label>Current Parent/Guardian 1:</mat-label>
          <input matInput type="string" placeholder="Enter the Current Parent/Guardian" formControlName="currentParent1"
            (focusout)="updateChangeValueLostFocus()" />
        </mat-form-field>
		<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_ParentGuardian_CurrentParent'"></help-text-btn>
      </div>
      <div class="col-4 inline">
        <mat-form-field class="w-100">
          <mat-label>Relationship</mat-label>
          <mat-select formControlName="relationship1">
            <mat-option *ngFor="let relation of relationShipData" [value]="relation.name">
              {{ relation.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
		<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_ParentGuardian_Relationship'"></help-text-btn>
      </div>
      <div class="col-4 inline">
        <mat-form-field class="w-100">
          <mat-label>Phone 1</mat-label>
          <input matInput type="string" placeholder="Enther Phone 1" formControlName="phone1" telephoneValidator
            (focusout)="updateChangeValueLostFocus()" />
        </mat-form-field>
		<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_ParentGuardian_Phone'"></help-text-btn>
      </div>
    </div>

    <!-- Current Parent/Guardian 2  Relationship  Phone 2-->
    <div style="padding-top: 30px" class="row">
      <div class="col-4">
        <mat-form-field>
          <mat-label>Currernt Parent/Guardian 2:</mat-label>
          <input matInput type="string" placeholder="currentParent" formControlName="currentParent2"
            (focusout)="updateChangeValueLostFocus()" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field appearance="fill">
          <mat-label>Relationship</mat-label>
          <mat-select formControlName="relationship2">
            <mat-option *ngFor="let relation of relationShipData" [value]="relation.name">
              {{ relation.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field>
          <mat-label>Phone 2</mat-label>
          <input matInput type="string" placeholder="Enter the Phone 2" formControlName="phone2" telephoneValidator
            (focusout)="updateChangeValueLostFocus()" />
        </mat-form-field>
      </div>
    </div>
  </form>

  <div class="row" *ngIf="(action==2 || action==3) ">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Past Edit - {{this.trackHistories.inaHistory.length}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="this.trackHistories.inaHistory.length>=1">
          <app-past-edit [section]="this.section"></app-past-edit>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

</mat-expansion-panel>